import { Box, Container } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router';
import { useTypedSelector } from '../../reducers';
import { useIsAuthenticated } from '../../hooks';
import ResetPasswordForm from './ResetPasswordForm';
import React from 'react';

export default function ResetPasswordScreen() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { viewMode } = useTypedSelector((state) => state.auth);

  const email = searchParams.get('email') || '';
  const token = searchParams.get('token') || '';

  const isAuthenticated = useIsAuthenticated();

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate(viewMode === 'admin' ? '/library' : '/users');
    }
  }, [isAuthenticated, navigate, viewMode]);

  React.useEffect(() => {
    if (!email || !token) {
      navigate('/forgot-password');
    }
  }, [email, token, navigate]);

  if (!email || !token) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100vh"
    >
      <Container>
        <Box display="flex" justifyContent="center">
          <Box width="100%" maxWidth={552}>
            <ResetPasswordForm email={email} token={token} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
